import DropzoneAudio from './DropzoneAudio'

export default DropzoneAudio
